<template>
  <article class="d-flex position-relative mb-3">
    <a :href="`${link}`" class="Card-link Card-link--secondary stretched-link"></a>
    <div class="Post-image" :style="`background-image: url('${post.imagePath}')`"></div>
    <div class="p-3 p-md-3 w-100 min-w-0">
      <div class="row mb-2">
        <div class="col-lg-9 col-xl-7">
          <h2 class="h5 Post-header mb-2 mb-lg-0">{{ post.title | stringLimit(90) }}</h2>
        </div>
        <div class="col-lg-3 col-xl-5 text-lg-right">
          <p v-if="post.type" class="h5 font-size-sm">{{ i18nValue.type }}: {{ post.type }}</p>
        </div>
      </div>
      <div v-if="postInfo" class="d-none d-sm-flex flex-wrap">
        <p class="h6 mb-2 mr-3" v-if="post.dateOpening">{{ i18nValue.dateOpening }}: {{ $date(post.dateOpening).format('L') }}</p>
        <p class="h6 mb-2 mr-3" v-if="post.dateClosing">{{ i18nValue.dateClosing }}: {{ $date(post.dateClosing).format('L') }}</p>
        <p v-if="post.identifier" class="h6 mb-2 mr-3">{{ i18nValue.identifier }}: {{ post.identifier }}</p>
      </div>
      <p class="font-size-sm d-none d-md-block">{{ post.description | stringLimit(300) }}</p>
    </div>
    <div class="d-none d-xl-flex flex-column justify-content-center flex-shrink-0">
      <div class="Post-arrow">
        <svg class="icon-small ml-2">
          <use xlink:href="#icon-chevron-right"></use>
        </svg>
      </div>
    </div>
  </article>
</template>

<script>
const locale = document.documentElement.lang;

export default {
  props: {
    post: {
      type: Object
    },
    postInfo: {
      type: Boolean,
      default: true
    },
    link: {
      type: String
    },
    i18n: {
      type: Object,
    }
  },
  data() {
    return {
      i18nValue: {...this.i18n}
    }
  },
  filters: {
    stringLimit: function(e, t) {
      return e ? (e = e.toString()).length <= t ? e : e.substr(0, t) + "..." : ""
    }
  }
}
</script>
